import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=c5e7ca20"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports